import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


import SpeechToTextLongTime from "./VoiceToVoice/SpeechToTextLongTime.jsx";
import TextToText from "./TextToText/TextToText.jsx";
import TextVoiceAssistantAbout from "./TextVoiceAssistantAbout.jsx";

import { useStore } from '../../hook-store/store.js';
import { ollamaMcpTestGet } from "../../utils/ollama/text-voice-assistant.js";

import { 
  ollamaNodeJsUrl,
} from "../../App.js";

import './TextVoiceAssistant.css';


function OllamaMcpServerGet(props) {

    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    const { isOllamaMcpServer } = store.uiStore;

    useEffect(() => {
      ollamaMcpTestGetHandler();

      const getInterval = setInterval(() => {
        ollamaMcpTestGetHandler();
      }, 1000*10);

      return () => {
        clearInterval(getInterval);
      }
    },[]);

    const ollamaMcpTestGetHandler = async () => {
      try {
        const resData = await ollamaMcpTestGet(
          ollamaNodeJsUrl,
          localStorage.getItem('token'),
        );

        // console.log(isOllamaMcpServer)
        if (resData) {
          dispatch('SET_ISOLLAMAMCPSERVER', true);
        } else {
          throw new Error('error occured')
        }

      } catch(err) {
        console.log(err);
        dispatch('SET_ISOLLAMAMCPSERVER', false);
        // throw err;
      }
    }
    return (
      <Fragment>
      </Fragment>
    );
}

export default OllamaMcpServerGet;
